// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Whether this adapter's site identity is stored on the adapter itself, or supplied
 * per-bank so one adapter can serve every site of a controller type.
 */
export enum VendorAddressing {
  /**
   * Legacy. `location` and `car_num_to_name` below are authored on the adapter and
   * describe ONE specific building, so the adapter cannot be reused at another site.
   * Default, so every adapter written before this field keeps its exact behaviour.
   */
  Absolute = 0,

  /**
   * `location` and `car_num_to_name` are SYNTHESIZED per-bank by `LiftCloud` from
   * `Archive.Bank.vendor_location_path` / `vendor_site_path` / `vendor_group_path`
   * and each `Archive.Lift.vendor_lift_path` / `vendor_group_name`. The adapter then
   * holds only leaf item names and is valid at every site of this controller type.
   */
  Leaf = 1,
}
